import React from "react";

import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles<Theme, { twelfths: number; topOffset: number }>(
  (theme) => {
    return {
      area: ({ twelfths, topOffset }) => ({
        position: "fixed",
        // the scrollable area is pretty much the full height, minus the header area
        height: `calc(100vh - ${
          theme.contentOffsets.AFTER_RECORD_HEADER + topOffset
        }px)`,
        // the scrollable area - takes in to account the presence of a menu to establish width
        width: `calc((100vw - ${
          theme.layoutDimensions.mainDrawerWidth + 25
        }px) * ${twelfths / 12})`,
        // prevent the area expanding when we make the browser wider than xl
        //  (fits in with the reset of the portal stopping at xl)
        maxWidth: theme.breakpoints.values.xl * (twelfths / 12) - 20,
      }),
    };
  }
);

type FullHeightAreaProps = {
  twelfths?: number;
  topOffset: number;
};

export const FullHeightWidthArea: React.FC<FullHeightAreaProps> = ({
  twelfths = 8,
  topOffset,
  children,
}) => {
  const classes = useStyles({ twelfths, topOffset });

  return <div className={classes.area}>{children}</div>;
};
